/*
 * vly.js — comportements de la page Velyforme (conv B, /es-es/).
 * Reprend ce que font sur velyforme.com le JS du thème Shrine, Kaching Bundles, Kaching Cart et AfterSell,
 * sans dépendre d'aucun d'eux. Tout est délégué sur document (le DOM peut être re-rendu) et gardé par un
 * drapeau : le script peut être chargé plusieurs fois sans double branchement.
 * Routes : window.vlyShop (posé par layout/vly.liquid, préfixées du sous-dossier du marché).
 */
(function () {
  if (window.__vlyInit) return;
  window.__vlyInit = true;

  var shop = window.vlyShop || {};
  var CART_JS = shop.cart || '/cart.js';
  var ADD_JS = shop.cartAdd || '/cart/add.js';
  var UPDATE_JS = shop.cartUpdate || '/cart/update.js';
  var CHANGE_JS = shop.cartChange || '/cart/change.js';

  /* ------------------------------------------------------------------ utilitaires */
  function formatMoney(cents) {
    var fmt = shop.moneyFormat || '€{{amount_with_comma_separator}}';
    var n = (Math.round(cents) / 100).toFixed(2);
    var parts = n.split('.');
    var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var withComma = intPart + ',' + parts[1];
    var withDot = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_with_comma_separator') return withComma;
      if (k === 'amount_no_decimals') return parts[0];
      if (k === 'amount_no_decimals_with_comma_separator') return intPart;
      return withDot;
    });
  }
  // Kaching entoure ses montants d'isolats Unicode (U+2068 / U+2069) : repris à l'identique.
  function kMoney(cents) { return '⁨' + formatMoney(cents) + '⁩'; }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw j; return j; });
    });
  }
  function getCart() { return fetch(CART_JS, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function store(key, val) { try { if (val === undefined) return localStorage.getItem(key); localStorage.setItem(key, val); } catch (e) { return null; } }
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  /* ------------------------------------------------------------------ minuteurs (lot + panier) */
  // Réinitialisé par visiteur : échéance stockée, relancée à expiration (jamais une date passée figée).
  function countdown(key, minutes) {
    var now = Date.now();
    var end = parseInt(store(key) || '0', 10);
    if (!end || end <= now) { end = now + minutes * 60000; store(key, String(end)); }
    var s = Math.max(0, Math.round((end - now) / 1000));
    return ('0' + Math.floor(s / 60)).slice(-2) + ':' + ('0' + (s % 60)).slice(-2);
  }
  setInterval(function () {
    document.querySelectorAll('vly-bundle').forEach(function (b) {
      var el = b.querySelector('[data-vly-timer]');
      if (el) el.textContent = ' ' + countdown('vly-bundle-timer', parseInt(b.dataset.timerMinutes || '30', 10)) + ' ';
    });
    var ct = document.querySelector('[data-vly-cart-timer]');
    if (ct && cartConfig()) ct.textContent = countdown('vly-cart-timer', cartConfig().timerMinutes || 10);
  }, 1000);

  /* ------------------------------------------------------------------ apparition au défilement (Shrine) */
  // .animate-section.animate--hidden .animate-item { opacity: 0 } : Shrine passe la section en animate--shown
  // quand elle entre dans le viewport.
  ready(function () {
    var secs = document.querySelectorAll('.animate-section.animate--hidden');
    function show(el) { el.classList.remove('animate--hidden'); el.classList.add('animate--shown'); }
    if (!('IntersectionObserver' in window)) { secs.forEach(show); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { show(en.target); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -50px 0px' });
    secs.forEach(function (el) { io.observe(el); });
  });

  /* ------------------------------------------------------------------ en-tête (Shrine) */
  document.addEventListener('click', function (e) {
    var summary = e.target.closest('#Details-menu-drawer-container > summary');
    var details = document.getElementById('Details-menu-drawer-container');
    if (summary && details) {
      e.preventDefault();
      if (details.hasAttribute('open')) closeMenu(details);
      else {
        details.setAttribute('open', '');
        requestAnimationFrame(function () { details.classList.add('menu-opening'); });
        document.body.classList.add('overflow-hidden-tablet');
        var hs = document.querySelector('.section-header'); if (hs) hs.classList.add('menu-open');
      }
      return;
    }
    if (details && details.hasAttribute('open') && (e.target.closest('.menu-drawer__close-btn') || !e.target.closest('#menu-drawer'))) {
      if (!e.target.closest('#Details-menu-drawer-container > summary')) closeMenu(details);
    }
    var searchClose = e.target.closest('.search-modal__close-button, .modal-overlay');
    if (searchClose) { var d = searchClose.closest('details'); if (d) d.removeAttribute('open'); }
  });
  function closeMenu(details) {
    details.classList.remove('menu-opening');
    document.body.classList.remove('overflow-hidden-tablet');
    var hs = document.querySelector('.section-header'); if (hs) hs.classList.remove('menu-open');
    setTimeout(function () { details.removeAttribute('open'); }, 200);
  }
  // sticky « on-scroll-up » de Shrine/Dawn (<sticky-header data-sticky-type="on-scroll-up">), repris à l'identique :
  // bornes du header mesurées UNE fois (jamais offsetTop pendant le défilement : il change dès que le header
  // colle, ce qui faisait basculer l'état en boucle), --header-height posé pour le top négatif du masquage.
  ready(function () {
    var hs = document.querySelector('.section-header');
    var sh = document.querySelector('sticky-header');
    if (!hs || !sh) return;
    var bounds = { top: 0, bottom: 0 }, current = 0;
    function measure() {
      document.documentElement.style.setProperty('--header-height', hs.offsetHeight + 'px');
      var wasFixed = hs.classList.contains('shopify-section-header-sticky');
      if (wasFixed) return;
      var r = hs.getBoundingClientRect();
      bounds.top = r.top + window.pageYOffset;
      bounds.bottom = bounds.top + r.height;
    }
    measure();
    window.addEventListener('resize', measure);
    window.addEventListener('scroll', function () {
      var y = window.pageYOffset || document.documentElement.scrollTop;
      if (y > current && y > bounds.bottom) {
        hs.classList.add('scrolled-past-header');
        requestAnimationFrame(function () { hs.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky'); });
      } else if (y < current && y > bounds.bottom) {
        hs.classList.add('scrolled-past-header');
        requestAnimationFrame(function () { hs.classList.add('shopify-section-header-sticky', 'animate'); hs.classList.remove('shopify-section-header-hidden'); });
      } else if (y <= bounds.top) {
        hs.classList.remove('scrolled-past-header');
        requestAnimationFrame(function () { hs.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate'); });
      }
      current = y;
    }, { passive: true });
  });

  /* ------------------------------------------------------------------ galerie produit (Dawn/Shrine) */
  function galleryParts(el) {
    var gallery = el.closest('media-gallery');
    if (!gallery) return null;
    return {
      gallery: gallery,
      list: gallery.querySelector('.product__media-list'),
      slides: Array.prototype.slice.call(gallery.querySelectorAll('.product__media-list > .product__media-item')),
      dots: Array.prototype.slice.call(gallery.querySelectorAll('.slider-counter__link--dots')),
      thumbs: Array.prototype.slice.call(gallery.querySelectorAll('.thumbnail-list__item'))
    };
  }
  function goTo(p, i) {
    i = Math.max(0, Math.min(p.slides.length - 1, i));
    var s = p.slides[i];
    p.list.scrollTo({ left: s.offsetLeft - p.list.firstElementChild.offsetLeft, behavior: 'smooth' });
    setActive(p, i);
  }
  function setActive(p, i) {
    p.slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
    p.dots.forEach(function (d, k) { d.classList.toggle('slider-counter__link--active', k === i); if (k === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
    p.thumbs.forEach(function (t, k) { var b = t.querySelector('button'); if (!b) return; if (k === i) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current'); });
    var active = p.thumbs[i];
    if (active) { var tl = active.parentElement; tl.scrollTo({ left: active.offsetLeft - tl.clientWidth / 2 + active.clientWidth / 2, behavior: 'smooth' }); }
  }
  function currentIndex(p) {
    var x = p.list.scrollLeft, best = 0, bd = Infinity;
    p.slides.forEach(function (s, k) { var d = Math.abs(s.offsetLeft - p.list.firstElementChild.offsetLeft - x); if (d < bd) { bd = d; best = k; } });
    return best;
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('media-gallery .thumbnail-list__item button');
    if (t) { e.preventDefault(); var p = galleryParts(t); goTo(p, p.thumbs.indexOf(t.closest('li'))); return; }
    var dot = e.target.closest('media-gallery .slider-counter__link--dots');
    if (dot) { var p2 = galleryParts(dot); goTo(p2, p2.dots.indexOf(dot)); return; }
    var nav = e.target.closest('media-gallery .slider-button--prev, media-gallery .slider-button--next');
    if (nav) {
      var p3 = galleryParts(nav);
      var inThumbs = nav.closest('.thumbnail-slider');
      if (inThumbs) {
        var tl = inThumbs.querySelector('.thumbnail-list');
        var step = (tl.firstElementChild ? tl.firstElementChild.clientWidth : 80) * 3;
        tl.scrollBy({ left: nav.classList.contains('slider-button--next') ? step : -step, behavior: 'smooth' });
      } else {
        goTo(p3, currentIndex(p3) + (nav.classList.contains('slider-button--next') ? 1 : -1));
      }
    }
  });
  ready(function () {
    document.querySelectorAll('media-gallery .product__media-list').forEach(function (list) {
      var tmr;
      list.addEventListener('scroll', function () {
        clearTimeout(tmr);
        tmr = setTimeout(function () { var p = galleryParts(list); setActive(p, currentIndex(p)); }, 80);
      }, { passive: true });
    });
  });

  /* ------------------------------------------------------------------ carrousels Splide (Shrine <splide-component>) */
  function loadSplide(cb) {
    if (window.Splide) return cb();
    var s = document.createElement('script');
    s.src = 'https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/js/splide.min.js';
    s.onload = cb;
    document.head.appendChild(s);
  }
  ready(function () {
    var comps = document.querySelectorAll('splide-component');
    if (!comps.length) return;
    loadSplide(function () {
      comps.forEach(function (c) {
        var d = c.dataset;
        var root = c.querySelector('.splide');
        if (!root || root.classList.contains('is-initialized')) return;
        var opts = {
          type: d.type || 'slide',
          perPage: parseInt(d.slidesMobile || '1', 10),
          perMove: 1,
          gap: (d.gapMobile || '15') + 'px',
          padding: { left: (d.sidePaddingMobile || '0') + 'px', right: (d.sidePaddingMobile || '0') + 'px' },
          arrows: true,
          pagination: true,
          autoplay: d.autoplay === 'true',
          interval: parseInt(d.autoplaySpeed || '5', 10) * 1000,
          mediaQuery: 'min',
          classes: {
            arrow: 'splide__arrow color-' + (d.arrowsColor || 'inverse'),
            page: 'splide__pagination__page color-' + (d.dotsColor || 'inverse') + ' dots-custom-color'
          },
          breakpoints: {
            750: {
              perPage: parseInt(d.slidesDesktop || '3', 10),
              perMove: parseInt(d.perMoveDesktop || '1', 10),
              gap: (d.gapDesktop || '40') + 'px',
              padding: { left: (d.sidePaddingDesktop || '0') + 'px', right: (d.sidePaddingDesktop || '0') + 'px' },
              destroy: d.destroyDesktop === 'true'
            }
          }
        };
        try { new window.Splide(root, opts).mount(); } catch (err) { /* grille statique en repli */ }
      });
    });
  });

  /* ------------------------------------------------------------------ lot (Kaching Bundles reconstruit) */
  function bundleData(b) {
    if (!b.__data) { try { b.__data = JSON.parse(b.querySelector('[data-vly-variants]').textContent); } catch (e) { b.__data = { variants: [] }; } }
    return b.__data;
  }
  function findVariant(b, opts) {
    var vs = bundleData(b).variants;
    for (var i = 0; i < vs.length; i++) {
      var ok = true;
      for (var k = 0; k < opts.length; k++) if (vs[i].options[k] !== opts[k]) { ok = false; break; }
      if (ok) return vs[i];
    }
    return null;
  }
  document.addEventListener('change', function (e) {
    var radio = e.target.closest('vly-bundle input[type="radio"]');
    if (radio) {
      var b = radio.closest('vly-bundle');
      b.querySelectorAll('.kaching-bundles__bar').forEach(function (bar) {
        var on = bar.contains(radio);
        bar.classList.toggle('kaching-bundles__bar--selected', on);
        // comme Kaching : lien <a> sur le cadeau de la barre sélectionnée seulement, <div> ailleurs
        var link = bar.querySelector('.kaching-bundles__free-gift__link');
        if (link && (link.tagName === 'A') !== on) {
          var n = document.createElement(on ? 'a' : 'div');
          n.className = link.className;
          var href = link.getAttribute('href') || link.getAttribute('data-href');
          if (on) { n.setAttribute('target', '_blank'); n.setAttribute('href', href); } else n.setAttribute('data-href', href);
          while (link.firstChild) n.appendChild(link.firstChild);
          link.replaceWith(n);
        }
      });
      return;
    }
    var sel = e.target.closest('vly-bundle .kaching-bundles__bar-variant-select');
    if (sel) {
      sel.setAttribute('data-value', sel.value);
      var row = sel.closest('.kaching-bundles__bar-variant');
      var opts = Array.prototype.map.call(row.querySelectorAll('select'), function (s) { return s.value; });
      var v = findVariant(sel.closest('vly-bundle'), opts);
      var img = row.querySelector('.kaching-bundles__bar-variant-image');
      if (v && v.image && img) img.src = v.image;
    }
  });
  // un clic sur la barre déjà sélectionnée ne doit pas la désélectionner ; les selects ne doivent pas re-cliquer le label
  document.addEventListener('click', function (e) {
    if (e.target.closest('vly-bundle select')) { e.stopPropagation(); }
  }, true);

  function selectedBundleItems(form) {
    var sid = form.getAttribute('data-vly-bundle-form');
    var b = document.querySelector('vly-bundle[data-section="' + sid + '"]') || document.querySelector('vly-bundle');
    if (!b) return null;
    var bar = b.querySelector('.kaching-bundles__bar--selected');
    if (!bar) return null;
    var counts = {}, order = [];
    bar.querySelectorAll('.kaching-bundles__bar-variant').forEach(function (row) {
      var opts = Array.prototype.map.call(row.querySelectorAll('select'), function (s) { return s.value; });
      var v = findVariant(b, opts);
      if (!v) return;
      if (!counts[v.id]) { counts[v.id] = 0; order.push(v.id); }
      counts[v.id] += 1;
    });
    var items = order.map(function (id) { return { id: id, quantity: counts[id] }; });
    if (bar.getAttribute('data-gift') === 'true' && b.dataset.giftVariant) items.push({ id: parseInt(b.dataset.giftVariant, 10), quantity: 1 });
    // Shopify empile les nouvelles lignes à l'envers (pièges 6.2) : on envoie dans l'ordre inverse
    return items.reverse();
  }
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-vly-bundle-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var spinner = form.querySelector('.loading-overlay__spinner');
    var items = selectedBundleItems(form);
    if (!items || !items.length) {
      items = [{ id: parseInt(form.querySelector('[name="id"]').value, 10), quantity: 1 }];
    }
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.classList.add('loading'); }
    if (spinner) spinner.classList.remove('hidden');
    postJSON(ADD_JS, { items: items })
      .then(function () { return syncCartRules(); })
      .then(function () { openCart('add-to-cart'); })
      .catch(function (err) {
        var wrap = form.closest('product-form') && form.closest('product-form').querySelector('.product-form__error-message-wrapper');
        if (wrap) { wrap.hidden = false; wrap.querySelector('.product-form__error-message').textContent = (err && (err.description || err.message)) || 'Error'; }
      })
      .then(function () {
        if (btn) { btn.removeAttribute('aria-disabled'); btn.classList.remove('loading'); }
        if (spinner) spinner.classList.add('hidden');
      });
  });

  /* ------------------------------------------------------------------ upsell AfterSell (shadow DOM) */
  ready(function () {
    document.querySelectorAll('vly-upsell').forEach(function (host) {
      var root = host.shadowRoot;
      if (!root && host.querySelector('template[shadowrootmode]')) {
        // navigateur sans shadow DOM déclaratif : on l'attache à la main
        var tpl = host.querySelector('template[shadowrootmode]');
        root = host.attachShadow({ mode: 'open' });
        root.appendChild(tpl.content.cloneNode(true));
        tpl.remove();
      }
      if (!root) return;
      root.addEventListener('change', function (e) {
        var sel = e.target.closest('select.select-dropdown');
        if (!sel) return;
        var opt = sel.options[sel.selectedIndex];
        sel.title = opt.textContent;
        var price = parseInt(opt.getAttribute('data-price'), 10);
        var pct = parseInt(sel.getAttribute('data-percent') || '0', 10);
        var card = sel.closest('.product-card');
        card.querySelector('[data-vly-price]').textContent = formatMoney(Math.floor(price * (100 - pct) / 100));
        card.querySelector('[data-vly-compare]').textContent = formatMoney(price);
      });
      root.addEventListener('click', function (e) {
        var add = e.target.closest('.add-button');
        if (add) {
          var sel = add.closest('.product-card').querySelector('select.select-dropdown');
          add.disabled = true;
          postJSON(ADD_JS, { items: [{ id: parseInt(sel.value, 10), quantity: 1 }] })
            .then(function () { openCart('upsell'); })
            .catch(function () {})
            .then(function () { add.disabled = false; });
          return;
        }
        var nav = e.target.closest('.carousel-button');
        if (nav) {
          var c = root.querySelector('.product-card-container');
          var card = c.querySelector('.product-card');
          var step = card ? card.getBoundingClientRect().width : c.clientWidth;
          c.scrollBy({ left: nav.classList.contains('right') ? step : -step, behavior: 'smooth' });
        }
      });
    });
  });

  /* ------------------------------------------------------------------ tiroir panier (Kaching Cart reconstruit) */
  var _cfg;
  function cartConfig() {
    if (_cfg !== undefined) return _cfg;
    var el = document.querySelector('[data-vly-cart-config]');
    try { _cfg = el ? JSON.parse(el.textContent) : null; } catch (e) { _cfg = null; }
    return _cfg;
  }
  var collapsed = false;

  // Le cadeau n'existe qu'avec le palier qui l'inclut ; l'option d'assurance n'est jamais seule.
  function syncCartRules() {
    var cfg = cartConfig();
    return getCart().then(function (cart) {
      if (!cfg) return cart;
      var mainQty = 0, giftQty = 0, others = 0, insQty = 0;
      cart.items.forEach(function (it) {
        if (cfg.bundleProductId && it.product_id === cfg.bundleProductId) mainQty += it.quantity;
        else if (cfg.gift && it.product_id === cfg.gift.productId) giftQty += it.quantity;
        else if (cfg.insurance && it.product_id === cfg.insurance.productId) insQty += it.quantity;
        else others += it.quantity;
      });
      var updates = {}, need = false;
      if (cfg.gift) {
        var want = mainQty >= (cfg.giftMinQty || 4) ? 1 : 0;
        if (giftQty !== want) { updates[cfg.gift.variantId] = want; need = true; }
      }
      if (cfg.insurance && insQty > 1) { updates[cfg.insurance.variantId] = 1; need = true; }
      if (cfg.insurance && insQty && !mainQty && !others) { updates[cfg.insurance.variantId] = 0; need = true; }
      return need ? postJSON(UPDATE_JS, { updates: updates }) : cart;
    });
  }

  function badge(svg, text) {
    return '<div class="kaching-cart__badge"><div style="display: inline-block; margin-right: 2px; width: 10px;">' + svg + '</div> <span style="white-space: normal; min-width: 0;">' + esc(text) + '</span></div>';
  }
  function qtyControls(val, key) {
    var s = cartConfig().svg;
    return '<div class="kaching-cart-item__quantity-controls" data-key="' + esc(key) + '"><button class="kaching-cart-item__quantity-btn kaching-cart-item__quantity-btn--decrement" aria-label="Decrease quantity">' + s.minus + '</button> <input class="kaching-cart-item__quantity-input" type="number" name="kaching-cart-quantity" aria-label="Quantity" min="1" step="1" value="' + val + '" style=""> <button class="kaching-cart-item__quantity-btn kaching-cart-item__quantity-btn--increment" aria-label="Increase quantity">' + s.plus + '</button></div>';
  }
  // prix barré unitaire d'une ligne (absent de /cart.js) : lot, cadeau et produit recommandé
  function compareOf(it) {
    var cfg = cartConfig() || {};
    var m = window.__vlyCompare || {};
    if (m[it.variant_id]) return m[it.variant_id];
    if (cfg.gift && it.variant_id === cfg.gift.variantId && cfg.gift.compare) return cfg.gift.compare;
    if (cfg.upsell) { for (var i = 0; i < cfg.upsell.variants.length; i++) if (cfg.upsell.variants[i].id === it.variant_id) return cfg.upsell.variants[i].compare; }
    if (cfg.insurance && it.variant_id === cfg.insurance.variantId && cfg.insurance.compare) return cfg.insurance.compare;
    return it.original_price;
  }
  function discountTitle(it, cfg) {
    var a = (it.line_level_discount_allocations || [])[0];
    var t = a && a.discount_application && a.discount_application.title;
    return t ? t.replace(cfg.discountPrefix || '', '') : '';
  }
  function productPath(handle, variantId) {
    var base = (shop.root || '/').replace(/\/$/, '');
    return base + '/products/' + encodeURIComponent(handle) + (variantId ? '?variant=' + variantId : '');
  }

  function renderCart(cart) {
    var cfg = cartConfig();
    var host = document.getElementById('cart-drawer');
    if (!cfg || !host) return;
    var s = cfg.svg;
    var count = cart.item_count;
    var visibleItems = cart.items.filter(function (it) { return !(cfg.insurance && it.product_id === cfg.insurance.productId); });
    var head = '<div class="kaching-cart__header kaching-cart__header--center"><p class="kaching-cart__heading" style="visibility: visible;">' + esc(cfg.heading) + ' • ' + count + '</p> <button class="kaching-cart__close" aria-label="Close cart">' + s.close + '</button></div> ';
    document.getElementById('kaching-cart').setAttribute('aria-label', cfg.heading + ' • ' + count);
    if (!visibleItems.length) {
      host.innerHTML = head + '<div class="kaching-cart__inner-empty"><div class="kaching-cart__empty-cart-content"><div class="kaching-cart__empty-cart-top-empty-space"></div> <div class="kaching-cart__empty-cart-central-content"><div class="kaching-cart__empty-cart-central-content-main"><div class="kaching-cart__empty-cart-icon"> ' + s.empty + '</div> <div class="kaching-cart__empty-cart-title">' + esc(cfg.empty) + '</div> </div> </div> <div class="kaching-cart__empty-cart-modules"></div></div></div> ';
      return;
    }
    var mainLines = [], gifts = [], rest = [];
    visibleItems.forEach(function (it) {
      if (cfg.bundleProductId && it.product_id === cfg.bundleProductId) mainLines.push(it);
      else if (cfg.gift && it.product_id === cfg.gift.productId) gifts.push(it);
      else rest.push(it);
    });
    var html = '';
    function extraItem(it, isGift) {
      var compare = compareOf(it);
      if (compare * it.quantity <= it.final_line_price) compare = 0;
      return '<div class="kaching-cart-item kaching-cart-extra-item kaching-cart-item__kaching-bundles-free-gift" data-line-key="' + esc(it.key) + '" data-product-handle="' + esc(it.handle) + '" data-product-id="' + it.product_id + '" data-requires-shipping="' + it.requires_shipping + '" data-has-selling-plan="false"><div class="kaching-cart-item__image-container kaching-cart-extra-item__image-container">' + s.extra_arrow + ' <a class="kaching-cart-item__link" href="' + productPath(it.handle, it.variant_id) + '"><img class="kaching-cart-item__image" loading="lazy" src="' + esc(it.image) + '" alt="' + esc(it.product_title) + '"> </a></div> <div class="kaching-cart-item__content"><div class="kaching-cart-item__content-left"><div class="kaching-cart-item__info"><a class="kaching-cart-item__title" href="' + productPath(it.handle, it.variant_id) + '">' + esc(it.product_title) + '</a> </div> ' + qtyControls(it.quantity, it.key) + ' </div> <div class="kaching-cart-item__content-right"><div class="kaching-cart-item__price-info"><div class="kaching-cart-item__total">' + (compare ? '<s class="kaching-cart-item__total-old">' + kMoney(compare * it.quantity) + '</s> ' : '') + '<span class="kaching-cart-item__total-final">' + (it.final_line_price === 0 ? esc(cfg.free) : kMoney(it.final_line_price)) + '</span></div> ' + (compare ? badge(s.bundle_tag, cfg.saves + ' ' + Math.round((1 - it.final_line_price / (compare * it.quantity)) * 100) + '%') : '') + '</div> <button type="button" class="kaching-cart-item__remove-btn" data-key="' + esc(it.key) + '" aria-label="Remove ' + esc(it.product_title) + ' from cart">' + s.remove + '</button></div></div></div>';
    }
    if (mainLines.length) {
      var first = mainLines[0];
      var qty = 0, finalTotal = 0, oldTotal = 0, rows = '';
      var unit = 0;
      mainLines.forEach(function (it) {
        qty += it.quantity; finalTotal += it.final_line_price;
        oldTotal += compareOf(it) * it.quantity;
        for (var u = 0; u < it.quantity; u++) {
          unit++;
          var sels = (it.options_with_values || []).map(function (o, oi) {
            var opts = (window.__vlyOptions && window.__vlyOptions[oi]) || [o.value];
            return '<select class="kaching-cart-selector" name="' + esc(o.name) + '" data-option-name="' + esc(o.name) + '" aria-label="' + esc(o.name) + '" style="cursor: pointer;">' + opts.map(function (v) { return '<option value="' + esc(v) + '"' + (v === o.value ? ' selected' : '') + '>' + esc(v) + '</option>'; }).join('') + '</select>';
          }).join('');
          rows += '<div class="kaching-variant-selectors-row" data-product-id="' + it.product_id + '" data-variant-id="' + it.variant_id + '" style="opacity: 1;' + (collapsed ? ' display: none;' : '') + '"><span class="kaching-variant-selectors-row__index" style="max-width: min-content;">#' + unit + ' </span> <div class="kaching-variant-selectors-row__selectors">' + sels + '</div></div> ';
        }
      });
      var tierTitle = cfg.tierTitles[String(qty)] || '';
      var names = (first.options_with_values || []).map(function (o) { return o.name; }).join(', ');
      var toggleText = (collapsed ? cfg.showItems : cfg.hideItems).replace('{n}', qty);
      html += '<div class="kaching-cart__module"><div class="kaching-cart-item-container"><div class="kaching-cart-item kaching-cart-item__multi-variant' + (gifts.length ? ' kaching-cart-item__with-extra-items' : '') + '" data-requires-shipping="true"><div class="kaching-cart-item__image-container" style="width: 80px; height: 80px; max-width: 80px;"><a class="kaching-cart-item__link" href="' + productPath(first.handle, first.variant_id) + '"><img class="kaching-cart-item__image" loading="lazy" src="' + esc(first.image) + '" alt="' + esc(first.product_title) + '"></a></div> <div class="kaching-cart-item__content"><div class="kaching-cart-item__content-left" style="flex-grow: 1;"><div class="kaching-cart-item__info"><a class="kaching-cart-item__title" href="' + productPath(first.handle, first.variant_id) + '"><span class="kaching-cart-item__bundle-quantity">' + qty + 'x </span> ' + esc(first.product_title) + '</a> ' + (tierTitle ? '<div class="kaching-cart__badge kaching-cart__badge--bundle"><div style="display: inline-block; margin-right: 2px; width: 10px;">' + s.bundle_tag + '</div> <span>' + esc(tierTitle) + '</span></div> ' : '') + (qty > 1 ? '<button class="kaching-cart-item-component__toggle-button" data-vly-toggle>' + esc(toggleText) + s.chevron_up + '</button> ' : '') + '<span class="kaching-cart-item__option-names"' + (collapsed ? ' style="display: none;"' : '') + '>' + esc(names) + ':</span> ' + rows + '</div> ' + qtyControls(qty, 'main') + ' </div> <div class="kaching-cart-item__content-right"><div class="kaching-cart-item__price-info"><div class="kaching-cart-item__total">' + (oldTotal > finalTotal ? '<s class="kaching-cart-item__total-old">' + kMoney(oldTotal) + '</s> ' : '') + '<span class="kaching-cart-item__total-final">' + kMoney(finalTotal) + '</span></div> ' + (oldTotal > finalTotal ? badge(s.bundle_tag, cfg.saves + ' ' + kMoney(oldTotal - finalTotal)) : '') + '</div> <button type="button" class="kaching-cart-item__remove-btn" data-key="main" aria-label="Remove ' + esc(first.product_title) + ' from cart">' + s.remove + '</button></div></div></div> ';
      html += '<div class="kaching-cart-extra-items-container">' + gifts.map(function (g) { return extraItem(g, true); }).join('') + ' </div></div> </div>';
    } else if (gifts.length) {
      html += '<div class="kaching-cart__module"><div class="kaching-cart-item-container">' + gifts.map(function (g) { return extraItem(g, true); }).join('') + '</div></div>';
    }
    rest.forEach(function (it) {
      var old = Math.max(compareOf(it), it.original_price) * it.quantity;
      html += '<div class="kaching-cart__module"><div class="kaching-cart-item-container"><div class="kaching-cart-item" data-line-key="' + esc(it.key) + '" data-requires-shipping="' + it.requires_shipping + '"><div class="kaching-cart-item__image-container" style="width: 80px; height: 80px; max-width: 80px;"><a class="kaching-cart-item__link" href="' + productPath(it.handle, it.variant_id) + '"><img class="kaching-cart-item__image" loading="lazy" src="' + esc(it.image) + '" alt="' + esc(it.product_title) + '"></a></div> <div class="kaching-cart-item__content"><div class="kaching-cart-item__content-left" style="flex-grow: 1;"><div class="kaching-cart-item__info"><a class="kaching-cart-item__title" href="' + productPath(it.handle, it.variant_id) + '">' + esc(it.product_title) + '</a> ' + (it.variant_title ? '<span class="kaching-cart-item__option-names">' + esc(it.variant_title) + '</span> ' : '') + '</div> ' + qtyControls(it.quantity, it.key) + ' </div> <div class="kaching-cart-item__content-right"><div class="kaching-cart-item__price-info"><div class="kaching-cart-item__total">' + (old > it.final_line_price ? '<s class="kaching-cart-item__total-old">' + kMoney(old) + '</s> ' : '') + '<span class="kaching-cart-item__total-final">' + kMoney(it.final_line_price) + '</span></div> ' + (old > it.final_line_price ? badge(s.bundle_tag, cfg.saves + ' ' + Math.round((1 - it.final_line_price / old) * 100) + '%') : '') + '</div> <button type="button" class="kaching-cart-item__remove-btn" data-key="' + esc(it.key) + '" aria-label="Remove ' + esc(it.product_title) + ' from cart">' + s.remove + '</button></div></div></div></div></div>';
    });

    // produit recommandé (masqué s'il est déjà au panier)
    var ups = cfg.upsell;
    var upsHtml = '';
    if (ups && !cart.items.some(function (it) { return it.product_id === ups.productId; })) {
      var v0 = ups.variants.filter(function (v) { return v.available; })[0] || ups.variants[0];
      var pct = cfg.upsellPercent || 0;
      var fin = Math.floor(v0.price * (100 - pct) / 100);
      var sels = ups.options.map(function (name, oi) {
        var vals = [];
        ups.variants.forEach(function (v) { if (vals.indexOf(v.options[oi]) < 0) vals.push(v.options[oi]); });
        return '<select class="kaching-cart-selector" name="' + esc(name) + '" data-option-name="' + esc(name) + '" aria-label="' + esc(name) + '">' + vals.map(function (x) { return '<option data-option-value-index="' + vals.indexOf(x) + '" value="' + esc(x) + '"' + (x === v0.options[oi] ? ' selected' : '') + '>' + esc(x) + '</option>'; }).join('') + '</select>';
      }).join('');
      upsHtml = '<div class="kaching-cart__module" style="margin-top: auto;"><div class="kaching-upsell-module--product-upsell"> <div class="kaching-cart__carousel"><button class="kaching-cart__carousel-nav-button kaching-cart__carousel-prev" aria-label="Previous slide" disabled="" style="display: none;">' + s.prev + '</button> <ul class="kaching-cart__carousel-list" aria-label="Product recommendations"><li class="kaching-cart__carousel-item kaching-product-upsell-item-container"><div class="kaching-product-upsell-item" data-product-id="' + ups.productId + '" data-variant-id="' + v0.id + '" data-product-handle="' + esc(ups.handle) + '"><div class="kaching-product-upsell-item__image-container"><a href="' + productPath(ups.handle) + '"><img class="kaching-product-upsell-item__image" loading="lazy" src="' + esc(ups.image) + '" alt="' + esc(ups.title) + '"></a></div> <div class="kaching-product-upsell-item__content"><a class="kaching-product-upsell-item__title" href="' + productPath(ups.handle) + '">' + esc(ups.title) + '</a> <div class="kaching-product-upsell-item__price-container"><div class="kaching-product-upsell-item__price-container-discounted"><span class="kaching-product-upsell-item__price-final">' + kMoney(fin) + '</span> <s class="kaching-product-upsell-item__price-old">' + kMoney(v0.compare) + '</s></div> <div class="kaching-product-upsell-item__badge">' + esc(cfg.saves) + ' ' + Math.round((1 - fin / v0.compare) * 100) + '%</div> </div> <span class="kaching-cart-item__option-names">' + esc(ups.options.join(', ')) + ':</span> <div class="kaching-product-upsell-item__footer"><div class="kaching-product-upsell-item__variant-selector-container">' + sels + '</div> <button class="kaching-product-upsell-item__add-to-cart">' + esc(cfg.upsellButton) + '</button></div></div></div></li></ul> <button class="kaching-cart__carousel-nav-button kaching-cart__carousel-next" aria-label="Next slide" disabled="" style="display: none;">' + s.next + '</button></div></div></div>';
    }
    var trust = cfg.trustText ? '<div class="kaching-cart__module"><div class="kaching-cart__trust-badges"><div class="kaching-cart__trust-badges-list"><div class="kaching-cart__trust-badge"><div class="kaching-cart__trust-badge-icon"><img alt="Custom trust badge icon" src="' + esc(cfg.trustIcon) + '"></div> <span class="kaching-cart__trust-badge-text">' + esc(cfg.trustText) + '</span></div></div></div></div><div class="kaching-cart__module"></div>' : '';

    // pied : assurance, remises, sous-total, paiement
    var ins = cfg.insurance, insOn = false;
    if (ins) insOn = cart.items.some(function (it) { return it.product_id === ins.productId; });
    var insHtml = ins ? '<div class="kaching-upsell-toggle-item"><div class="kaching-upsell-toggle-item__image-container"><img class="kaching-upsell-toggle-item__image" loading="lazy" src="' + esc(ins.image) + '" alt="' + esc(ins.title) + '"></div> <div class="kaching-upsell-toggle-item__content"><div class="kaching-upsell-toggle-item__left-content"><div class="kaching-upsell-toggle-item__title-container"><span class="kaching-upsell-toggle-item__title">' + esc(ins.title) + '</span> <div class="kaching-upsell-toggle-item__price-container"><span class="kaching-upsell-toggle-item__price-final">' + kMoney(ins.price) + '</span> ' + (ins.compare ? '<s class="kaching-upsell-toggle-item__price-old">' + kMoney(ins.compare) + '</s>' : '') + '</div></div> <span class="kaching-upsell-toggle-item__description">' + esc(ins.description) + '</span></div> <div class="kaching-upsell-toggle-item__toggle-container"><button class="kaching-cart-toggle' + (insOn ? ' kaching-cart-toggle__active' : '') + '" data-vly-insurance aria-label="' + esc(ins.title) + '"><div class="kaching-cart-toggle__handle">&nbsp;</div></button></div></div></div>' : '';
    var compareAll = 0, discTitle = '';
    cart.items.forEach(function (it) {
      compareAll += Math.max(compareOf(it), it.original_price) * it.quantity;
      if (!discTitle) discTitle = discountTitle(it, cfg);
    });
    var discount = compareAll - cart.total_price;
    var discHtml = discount > 0 ? '<div class="kaching-cart__cart-discounts"><div class="kaching-cart__cart-discounts-title">' + esc(cfg.discounts) + ' ' + (discTitle ? '<div class="kaching-cart__cart-discounts-badge" data-is-discount-code="false"> ' + s.discount_tag + ' <span style="max-width: 130px; text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">' + esc(discTitle) + '</span> </div>' : '') + '</div> <div class="kaching-cart__cart-discounts-amount">' + kMoney(-discount).replace('⁨€-', '⁨-€') + '</div></div>' : '';
    var pays = (cfg.payments || []).map(function (p) { return '<img decoding="async" fetchpriority="high" src="' + esc(p.src) + '" alt="' + esc(p.name) + '" class="kaching-cart__payment-icon-default kaching-cart__payment-icon-' + esc(p.name) + '">'; }).join('');
    var foot = '<div class="kaching-cart__footer"> ' + insHtml + discHtml + '<div class="kaching-cart__subtotal">' + esc(cfg.subtotal) + ' <span> ' + kMoney(cart.total_price) + '</span></div> <button type="button" id="kaching-cart__checkout-button" class="kaching-cart__checkout-button" name="checkout" data-vly-checkout aria-label="Proceed to Checkout"><span class="kaching-cart__checkout-button-text"><span class="kaching-cart__checkout-button-spinner" style="display:none"></span> <span class="kaching-cart__checkout-button-label">' + esc(cfg.checkout) + ' • ' + kMoney(cart.total_price) + '</span></span> <span class="kaching-cart__checkout-button-text-upsell-toggle" style="display: none"><span></span></span></button> <div class="kaching-cart__payment-icons">' + pays + ' </div>' + (cfg.guarantee ? '<button type="button" class="kaching-cart__continue-shopping">' + esc(cfg.guarantee) + '</button>' : '') + '</div> ';

    host.innerHTML = head + '<div class="kaching-cart__contents"><div class="kaching-cart__module"><div class="kaching-cart__announcement-bar">' + esc(cfg.timerText) + ' <strong data-vly-cart-timer>' + countdown('vly-cart-timer', cfg.timerMinutes || 10) + '</strong> </div></div><div class="kaching-cart__module"></div>' + html + upsHtml + trust + '</div> ' + foot;
  }

  function refreshCart() { return getCart().then(function (c) { renderCart(c); updateBubble(c); return c; }); }
  function updateBubble(cart) {
    var b = document.getElementById('cart-icon-bubble');
    if (!b) return;
    var n = b.querySelector('.cart-count-bubble');
    if (cart.item_count > 0) {
      if (!n) { n = document.createElement('div'); n.className = 'cart-count-bubble'; b.appendChild(n); }
      n.innerHTML = '<span aria-hidden="true">' + (cart.item_count < 100 ? cart.item_count : '') + '</span><span class="visually-hidden">' + cart.item_count + '</span>';
    } else if (n) n.remove();
  }
  function openCart(source) {
    var wrap = document.getElementById('kaching-cart');
    if (!wrap) { location.href = (shop.root || '/').replace(/\/$/, '') + '/cart'; return; }
    refreshCart().then(function () {
      wrap.classList.add('active');
      wrap.setAttribute('data-open', 'true');
      if (source) wrap.setAttribute('data-open-source', source);
      document.documentElement.style.overflow = 'hidden';
    });
  }
  function closeCart() {
    var wrap = document.getElementById('kaching-cart');
    if (!wrap) return;
    wrap.classList.remove('active');
    wrap.removeAttribute('data-open');
    document.documentElement.style.overflow = '';
  }
  window.vlyOpenCart = openCart;

  function mainLinesFrom(cart) {
    var cfg = cartConfig();
    return cart.items.filter(function (it) { return cfg && it.product_id === cfg.bundleProductId; });
  }
  function busy(on) { var d = document.getElementById('cart-drawer'); if (d) d.style.opacity = on ? '0.6' : ''; }
  function mutate(p) {
    busy(true);
    return p.then(function () { return syncCartRules(); }).then(refreshCart).catch(refreshCart).then(function () { busy(false); });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-vly-cart-open], #cart-icon-bubble')) { e.preventDefault(); openCart('cart-button'); return; }
    if (!e.target.closest('#kaching-cart')) return;
    if (e.target.closest('.kaching-cart__close') || e.target.classList.contains('kaching-cart__overlay')) { closeCart(); return; }
    if (e.target.closest('[data-vly-toggle]')) { collapsed = !collapsed; refreshCart(); return; }
    if (e.target.closest('[data-vly-checkout]')) {
      var b = e.target.closest('[data-vly-checkout]');
      var sp = b.querySelector('.kaching-cart__checkout-button-spinner'); if (sp) sp.style.display = '';
      location.href = shop.checkout || '/checkout';
      return;
    }
    var ins = e.target.closest('[data-vly-insurance]');
    if (ins) {
      var cfg = cartConfig();
      var on = ins.classList.contains('kaching-cart-toggle__active');
      var u = {}; u[cfg.insurance.variantId] = on ? 0 : 1;
      ins.classList.toggle('kaching-cart-toggle__active', !on);
      mutate(postJSON(UPDATE_JS, { updates: u }));
      return;
    }
    var addUps = e.target.closest('.kaching-product-upsell-item__add-to-cart');
    if (addUps) {
      var cfgU = cartConfig();
      var item = addUps.closest('.kaching-product-upsell-item');
      var opts = Array.prototype.map.call(item.querySelectorAll('select'), function (x) { return x.value; });
      var v = cfgU.upsell.variants.filter(function (x) { return x.options.join('|') === opts.join('|'); })[0];
      if (v) mutate(postJSON(ADD_JS, { items: [{ id: v.id, quantity: 1 }] }));
      return;
    }
    var rm = e.target.closest('.kaching-cart-item__remove-btn');
    if (rm) {
      var key = rm.getAttribute('data-key');
      if (key === 'main') {
        mutate(getCart().then(function (cart) {
          var up = {}; mainLinesFrom(cart).forEach(function (it) { up[it.variant_id] = 0; });
          return postJSON(UPDATE_JS, { updates: up });
        }));
      } else mutate(postJSON(CHANGE_JS, { id: key, quantity: 0 }));
      return;
    }
    var qb = e.target.closest('.kaching-cart-item__quantity-btn');
    if (qb) {
      var ctl = qb.closest('.kaching-cart-item__quantity-controls');
      var k = ctl.getAttribute('data-key');
      var inc = qb.classList.contains('kaching-cart-item__quantity-btn--increment');
      if (k === 'main') {
        mutate(getCart().then(function (cart) {
          var lines = mainLinesFrom(cart); if (!lines.length) return;
          var last = lines[lines.length - 1];
          var up = {}; up[last.variant_id] = Math.max(0, last.quantity + (inc ? 1 : -1));
          return postJSON(UPDATE_JS, { updates: up });
        }));
      } else {
        var cur = parseInt(ctl.querySelector('input').value, 10) || 1;
        mutate(postJSON(CHANGE_JS, { id: k, quantity: Math.max(0, cur + (inc ? 1 : -1)) }));
      }
    }
  });
  // changement de couleur/taille d'une unité du lot dans le tiroir : -1 sur l'ancienne variante, +1 sur la nouvelle
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('#kaching-cart .kaching-variant-selectors-row select');
    if (sel) {
      var row = sel.closest('.kaching-variant-selectors-row');
      var oldId = parseInt(row.getAttribute('data-variant-id'), 10);
      var opts = Array.prototype.map.call(row.querySelectorAll('select'), function (x) { return x.value; });
      var b = document.querySelector('vly-bundle');
      var nv = b && findVariant(b, opts);
      if (!nv || nv.id === oldId) return;
      mutate(getCart().then(function (cart) {
        var q = {}; cart.items.forEach(function (it) { q[it.variant_id] = (q[it.variant_id] || 0) + it.quantity; });
        var up = {}; up[oldId] = Math.max(0, (q[oldId] || 0) - 1); up[nv.id] = (q[nv.id] || 0) + 1;
        return postJSON(UPDATE_JS, { updates: up });
      }));
      return;
    }
    var inp = e.target.closest('#kaching-cart .kaching-cart-item__quantity-input');
    if (inp) {
      var k2 = inp.closest('.kaching-cart-item__quantity-controls').getAttribute('data-key');
      var val = Math.max(0, parseInt(inp.value, 10) || 0);
      if (k2 !== 'main') mutate(postJSON(CHANGE_JS, { id: k2, quantity: val }));
      else mutate(getCart().then(function (cart) {
        var lines = mainLinesFrom(cart); var total = lines.reduce(function (a, it) { return a + it.quantity; }, 0);
        var last = lines[lines.length - 1]; if (!last) return;
        var up = {}; up[last.variant_id] = Math.max(0, last.quantity + (val - total));
        return postJSON(UPDATE_JS, { updates: up });
      }));
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });

  ready(function () {
    // valeurs d'options du produit du lot, pour les sélecteurs par unité du tiroir
    var b = document.querySelector('vly-bundle');
    if (b) {
      var data = bundleData(b), vals = [];
      (data.options || []).forEach(function (_, oi) {
        vals[oi] = [];
        data.variants.forEach(function (v) { if (vals[oi].indexOf(v.options[oi]) < 0) vals[oi].push(v.options[oi]); });
      });
      window.__vlyOptions = vals;
      window.__vlyCompare = {};
      data.variants.forEach(function (v) { if (v.compare) window.__vlyCompare[v.id] = v.compare; });
    }
    // comme Kaching Cart : le tiroir est rendu (fermé) dès le chargement
    refreshCart().catch(function () {});
  });
})();
